<template>
  <div class="q-page">
    <div class="container py-5">

      <nav aria-label="breadcrumb" class="mb-4">
        <ol class="breadcrumb q-breadcrumb">
          <li class="breadcrumb-item"><router-link :to="{ name: 'Home' }">Inicio</router-link></li>
          <li class="breadcrumb-item active">Políticas de privacidad</li>
        </ol>
      </nav>

      <div class="row justify-content-center">
        <div class="col-lg-8">
          <p class="q-section-title mb-4">Políticas de privacidad</p>

          <div class="q-policy-block">
            <h2 class="q-policy-subtitle">Recopilación de datos</h2>
            <p>Al realizar una compra o registrarse en nuestro sitio, recopilamos datos personales como nombre, correo electrónico, teléfono y dirección de entrega. Esta información es utilizada exclusivamente para procesar pedidos y mejorar la experiencia de compra.</p>
          </div>

          <div class="q-policy-block">
            <h2 class="q-policy-subtitle">Uso de la información</h2>
            <p>Los datos recopilados son utilizados para:</p>
            <ul class="q-policy-list">
              <li>Procesar y gestionar sus pedidos.</li>
              <li>Enviar confirmaciones y actualizaciones sobre su compra.</li>
              <li>Mejorar nuestros productos y servicios.</li>
              <li>Cumplir con obligaciones legales y regulatorias.</li>
            </ul>
          </div>

          <div class="q-policy-block">
            <h2 class="q-policy-subtitle">Protección de datos</h2>
            <p>Implementamos medidas de seguridad para proteger su información personal contra accesos no autorizados, alteraciones o divulgaciones. Sus datos nunca serán vendidos ni compartidos con terceros sin su consentimiento expreso.</p>
          </div>

          <div class="q-policy-block">
            <h2 class="q-policy-subtitle">Cookies</h2>
            <p>Nuestro sitio utiliza cookies para mejorar la navegación y personalizar su experiencia. Puede configurar su navegador para rechazar cookies, aunque esto puede afectar algunas funcionalidades del sitio.</p>
          </div>

          <div class="q-policy-block">
            <h2 class="q-policy-subtitle">Sus derechos</h2>
            <p>Tiene derecho a acceder, rectificar o eliminar sus datos personales en cualquier momento. Para ejercer estos derechos, contáctenos a través de nuestro formulario de contacto.</p>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "PrivacyPolicy",
};
</script>

<style scoped>
.q-breadcrumb { background: transparent; padding: 0; margin: 0; }
.q-breadcrumb .breadcrumb-item { font-size: 14px; color: var(--q-text-subtle); }
.q-breadcrumb .breadcrumb-item a { color: var(--q-text-muted); }
.q-breadcrumb .breadcrumb-item a:hover { color: var(--primary-color); }
.q-breadcrumb .breadcrumb-item + .breadcrumb-item::before { color: var(--q-text-subtle); }

.q-policy-block {
  margin-bottom: 2rem;
  padding-bottom: 2rem;
  border-bottom: 1px solid var(--q-border);
}
.q-policy-block:last-child { border-bottom: none; }

.q-policy-subtitle {
  font-family: var(--q-font-display);
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: var(--q-text);
  margin-bottom: 10px;
}

.q-policy-block p {
  font-size: 14px;
  line-height: 1.8;
  color: var(--q-text-muted);
  margin: 0;
}

.q-policy-list {
  margin: 8px 0 0 0;
  padding-left: 20px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.q-policy-list li {
  font-size: 14px;
  line-height: 1.8;
  color: var(--q-text-muted);
}
</style>
